export default __webpack_public_path__ + "static/media/2023-07-04.28e39b05.png";